import React from 'react';
import PropTypes from 'prop-types';
import { NumberFormat } from 'App/babel/utils/numberFormat';
import { Tooltip } from '@upsales/components';

export default class NameSoliditet extends React.Component {
	constructor(props) {
		super(props);

		const t = Tools.$translate;

		this.lang = {
			headquarters: t('default.parentCompany'),
			branch: t('default.branchOffice'),
			city: t('address.city'),
			numEmployees: t('default.numOfEmployees'),
			turnover: t('default.turnover')
		};
	}

	getSubtitle() {
		const numberFormat = new NumberFormat();
		const address = {
			city: this.props.account.city,
			country: this.props.account.country
		};

		const flag =
			address && address.country ? (
				<b
					style={{ marginRight: 10 }}
					className={'icon flag-icon flag-icon-' + address.country.toLowerCase()}
				/>
			) : null;
		const addressSpan = address ? (
			<span style={{ verticalAlign: 'middle' }}>
				{flag}{' '}
				<Tooltip title={this.lang.city} position="top" key={'city' + this.props.account.id}>
					<span>{address.city}</span>
				</Tooltip>
			</span>
		) : null;

		const numEmployeesText = numberFormat.short(this.props.account.noOfEmployeesExact);
		const numEmployees = (
			<span style={{ marginLeft: '10px' }}>
				<i className="fa fa-user" /> {numEmployeesText}
			</span>
		);
		const turnoverText = numberFormat.short(this.props.account.turnover * 1000);
		const turnover = (
			<span style={{ marginLeft: '10px' }}>
				<i className="fa fa-bar-chart" /> {turnoverText}
			</span>
		);

		return (
			<span className="subtitle">
				{addressSpan}
				<Tooltip title={this.lang.numEmployees} position="top" key={'numEmployees' + this.props.account.id}>
					{numEmployees}
				</Tooltip>
				<Tooltip title={this.lang.turnover} position="top" key={'turnover' + this.props.account.id}>
					{turnover}
				</Tooltip>
			</span>
		);
	}

	getAdditionalInfo() {
		if (this.props.account.isHeadqueraters === 0) {
			return <span className="additional-info">{this.lang.branch}</span>;
		} else if (this.props.account.rootParentDuns === null) {
			return <span className="additional-info">{this.lang.headquarters}</span>;
		}

		return null;
	}

	render() {
		const subtitle = this.getSubtitle();

		const hasGroupTreeVirtualizedList = Tools.FeatureHelper.hasSoftDeployAccess('GROUP_TREE_VIRTUALIZED_LIST');
		const Component = hasGroupTreeVirtualizedList && !this.props.createNewAccountRow ? 'div' : 'td';

		return (
			<Component
				className={`DataSourceColumn ${this.props.field.className} ${
					hasGroupTreeVirtualizedList && !this.props.createNewAccountRow ? 'align-items-center' : ''
				}`}
			>
				<div>
					<span className="row-text">
						{this.props.account.name} {this.getAdditionalInfo()}
					</span>
					{subtitle}
				</div>
			</Component>
		);
	}
}

NameSoliditet.propTypes = {
	account: PropTypes.object,
	field: PropTypes.object,
	createNewAccountRow: PropTypes.bool
};
